import { useState, useEffect } from "react";
import banner1 from "../assets/images/Banner1.png";
import banner2 from "../assets/images/Banner2.png";
import banner3 from "../assets/images/Banner3.png";
import "../assets/css/style.css"; 

const banners = [banner1, banner2, banner3];

function Banners() {
  const [currentIndex, setCurrentIndex] = useState(0);

  useEffect(() => {
    const interval = setInterval(() => {
      setCurrentIndex((prevIndex) => (prevIndex + 1) % banners.length);
    }, 3000); 
    return () => clearInterval(interval);
  }, []);

  return (
    <div
      className="projects-banner"
      style={{
        backgroundImage: `url(${banners[currentIndex]})`,
        transition: "background-image 1s ease-in-out",
      }}
    ></div>
  );
}
export default Banners;

